import { render } from "./CreateQuestion.vue?vue&type=template&id=717e3c42&scoped=true"
import script from "./CreateQuestion.vue?vue&type=script&lang=js"
export * from "./CreateQuestion.vue?vue&type=script&lang=js"

import "./CreateQuestion.vue?vue&type=style&index=0&id=717e3c42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717e3c42"]])

export default __exports__